import axios from "axios";
import React, { useEffect, useState } from "react";
import HOC from "../../layout/HOC";
import Baseurl from "../../../Baseurl";
import { CgProfile } from "react-icons/cg";
import { Oval } from "react-loader-spinner";
import { IoMdClose } from "react-icons/io";

const StudentPremium = () => {
  const dummyData = [
    {
      plan_type: "yearly",
      purchase_date: "dummy",
      total_cost: "dummy",
      plan_start_date: "2022-00-23T00:57:47.728Z",
      plan_end_date: "2022-00-23T00:57:47.728Z",
      payment_id: "dummy",
    },
  ];
  const [parents, setParents] = useState([]);
  const token = localStorage.getItem("studyhox");
  const [loading, setLoading] = useState(true);
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [parentId, setParentId] = useState([]);
  const [popup, setPopup] = useState(false);
  const [inputText, setInputText] = useState("");
  const [Details, setDetails] = useState(dummyData);
  const [visible, setvisible] = useState(false);

  let inputHandler = (e) => {
    var lowerCase = e.target.value.toLowerCase();
    setInputText(lowerCase);
  };

  const auth = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  //Get right date
  const formatData = (date) => {
    const str = date.substr(0, 10);
    return str;
  };
  // Get Parents
  let users = [];
  useEffect(() => {
    let URL = `${Baseurl()}studentsubscription/getallsub`;
    axios
      .get(URL, auth)
      .then((res) => {
        console.log("hii");
        for (var i = 0; i < res.data.data.length; i++) {
          users.push(res.data.data[i].studentId);
        }
        setParents(users);
        console.log(res.data);
        console.log("users", users);
      })
      .then(setLoading(false))

      .catch((error) => console.log(error));
  }, []);

  const filteredData = parents.filter((item) => {
    if (inputText === "") {
      return item;
    } else {
      return item?.parentothernames.toLowerCase().includes(inputText);
    }
  });

  const handleClick = (data) => {
    setParentId(data._id);
  };

  const getSingle = (id) => {
    axios
      .get(`${Baseurl()}studentsubscription/getsubByid/${id}`, auth)
      .then((res) => {
        setDetails(res.data.data[0]);
        console.log("details", Details);
      })

      .catch((error) => console.log(error));
  };

  return (
    <>
      <div className="pb-4 sticky w-full  top-0 bg-slate-900 flex items-center justify-between">
        <span className="tracking-widest text-blue-400 font-semibold uppercase text-lg">
          All Students{" "}
        </span>

        <span clasName="tracking-widest text-black font-semibold uppercase text-black">
          <input
            type="search"
            onChange={inputHandler}
            className="px-2 py-2"
            placeholder="Search..."
            style={{ color: "black", outline: "none" }}
          />
        </span>
      </div>
      <section
        style={{ background: "rgba(0,0,0,0.4)" }}
        className={
          popup
            ? "fixed top-0 left-0 wcomp transition-all duration-150 w-full flex justify-center items-center h-screen "
            : "hidden"
        }
      >
        <div
          style={{ maxHeight: "90vh" }}
          className="bg-white p-3 px-5 lg:w-3/6  md:w-4/6 w-5/6 mx-auto  rounded-lg"
        >
          <div className="flex justify-between">
            <span className=" font-semibold text-indigo-500 ">
              Plan Details
            </span>
            <div className="text-indigo-600 py-0.5 text-2xl cursor-pointer font-medium tracking-wider">
              <IoMdClose
                onClick={() => {
                  setPopup(false);
                  // setCourseName("");
                }}
              />{" "}
            </div>
          </div>
          {/* form */}

          <form className="grid  grid-cols-1 gap-x-7 gap-y-4 py-4">
            <div className="inline-flex  w-full flex-col">
              <label
                htmlFor="name"
                className="text-gray-800 mb-1.5 tracking-wider font-semibold text-sm"
              >
                Amount Paid
              </label>
              <span className="bg-gray-100 text-gray-800 tracking-wider text-sm rounded-full py-1 px-2 outline-indigo-400">
                {Details.total_cost}
              </span>
            </div>
            <div className="inline-flex  w-full flex-col">
              <label
                htmlFor="name"
                className="text-gray-800 mb-1.5 tracking-wider font-semibold text-sm"
              >
                Start Date
              </label>
              <span className="bg-gray-100 text-gray-800 tracking-wider text-sm rounded-full py-1 px-2 outline-indigo-400">
                {Details.plan_start_date
                  ? formatData(Details.plan_start_date)
                  : ""}
              </span>
            </div>
            <div className="inline-flex  w-full flex-col">
              <label
                htmlFor="name"
                className="text-gray-800 mb-1.5 tracking-wider font-semibold text-sm"
              >
                End Date
              </label>
              <span className="bg-gray-100 text-gray-800 tracking-wider text-sm rounded-full py-1 px-2 outline-indigo-400">
                {Details.plan_end_date ? formatData(Details.plan_end_date) : ""}
              </span>
            </div>
            <div className="inline-flex  w-full flex-col">
              <label
                htmlFor="name"
                className="text-gray-800 mb-1.5 tracking-wider font-semibold text-sm"
              >
                Payment Id
              </label>
              <span className="bg-gray-100 text-gray-800 tracking-wider text-sm rounded-full py-1 px-2 outline-indigo-400">
                {Details.payment_id}
              </span>
            </div>
            <div className="inline-flex  w-full flex-col">
              <label
                htmlFor="name"
                className="text-gray-800 mb-1.5 tracking-wider font-semibold text-sm"
              >
                Plan Type
              </label>
              <span className="bg-gray-100 text-gray-800 tracking-wider text-sm rounded-full py-1 px-2 outline-indigo-400">
                {Details.plan_type}
              </span>
            </div>
          </form>
        </div>
      </section>
      <div className=" wcomp overflow-y-auto">
        <table className="table-auto  w-full text-left whitespace-no-wrap">
          <thead>
            <tr className="bg-blue-400 border-b border-gray-700 shadow-xl text-white">
              <th className="px-4 py-3  tracking-widest font-medium text-2xl rounded-tl-lg ">
                <CgProfile />
              </th>
              <th className="px-4 py-3 title-font tracking-widest font-medium md:text-base text-sm  ">
                Name
              </th>
              <th className="px-4 py-3 title-font tracking-widest font-medium md:text-base text-sm  ">
                Cloudinary Id
              </th>{" "}
              {/* <th className="px-4 py-3 title-font tracking-widest font-medium md:text-base text-sm  ">
                Roll No.
              </th> */}
              <th className="px-4 py-3 title-font tracking-widest rounded-tr-lg font-medium md:text-base text-sm  ">
                Phone
              </th>
              <th className="px-4 py-3 title-font tracking-widest rounded-tr-lg font-medium md:text-base text-sm  ">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <Oval color="white" />
            ) : (
              filteredData.map((data) => {
                return (
                  <tr className="tracking-wider bg-[rgb(30,39,66)] ">
                    <td className="px-2 py-3 w-24 md:w-32">
                      <img
                        src={
                          data.profilePic
                            ? data.profilePic
                            : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTCyOhbogPKefkCLuaejt8IPmVxdzpd7ToK-g&usqp=CAU"
                        }
                        alt=""
                        className="w-10 md:w-14 h-10 md:h-14 object-cover rounded-full"
                      />
                    </td>
                    <td className="px-4 py-3">
                      {data.name}
                    </td>
                    <td className="px-4 py-3">{data.cloudinary_id}</td>
                    {/* <td className="px-4 py-3">{data.rollnumber}</td> */}
                    <td className="px-4 py-3">{data.mobilenumber}</td>
                    <td className="px-4 py-3">
                      {" "}
                      <button
                        className="w-full bg-blue-700  py-1 rounded-md text-white "
                        onClick={() => {
                          console.log(data._id);
                          getSingle(data._id);
                          setPopup(!popup);
                          handleClick(data);
                        }}
                      >
                        Details
                      </button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default HOC(StudentPremium);
